<div class="card rounded-3 mb-4 shadow border-gray">
  <div class="card-body">
    <h5 class="card-title fw-bold fs-5 mb-3">{{ 'geomarker.business_hours' | translate }}</h5>
    <p class="schedule mb-0" [innerHTML]="schedule()"></p>
  </div>
</div>
